import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Home from '../Components/Home/Home';
import Login from '../Components/Login/Login';
import Info from '../Components/Info/Info';
import Notifications from '../Components/Notifications/Notifications';
import { useIsAdmin, useIsFacultyAdmin } from '../utils/utilFunctions';
import StudyPrograms from '../Components/StudyPrograms/StudyPrograms';
import DomainForm from '../Components/Domains/DomainForm/DomainForm';
import StudyProgramForm from '../Components/StudyPrograms/StudyProgramForm/StudyProgramForm';
import FundamentalDomainForm from '../Components/Domains/DomainForm/FundamentalDomainForm';
import DomainTabs from '../Components/Domains/DomainTabs';
import Laboratories from '../Components/Laboratory/Laboratories';
import LaboratoryForm from '../Components/Laboratory/LaboratoryForm/LaboratoryForm';
import Indicators from '../Components/Indicator/Indicators';
import IndicatorForm from '../Components/Indicator/IndicatorForm/IndicatorForm';
import Subjects from '../Components/Subject/Subjects';
import SubjectForm from '../Components/Subject/SubjectForm/SubjectForm';
import SubjectShortForm from '../Components/Subject/SubjectShortForm/SubjectShortForm';
import IndicatorsStats from '../Components/Indicator/IndicatorsStats';
import PlanLaboratories from '../Components/Subject/PlanLaboratories/PlanLaboratories';
import LaboratoriesContent from '../Components/Subject/LaboratoriesContent/LaboratoriesContent';
import LaboratoriesEquipment from '../Components/Subject/LaboratoriesEquipment/LaboratoriesEquipment';
import LaboratoriesCapacity from '../Components/Subject/LaboratoriesCapacity/LaboratoriesCapacity';
import ReportsList from '../Components/ReportFiles/ReportsList';
import ReportForm from '../Components/ReportFiles/ReportForm/ReportForm';
import ScienceBranchForm from '../Components/Domains/DomainForm/ScienceBranchForm';
import LearningCompetences from '../Components/StudyPrograms/LearningCompetences';
import DisciplineGroups from '../Components/DisciplineGroups/DisciplineGroups';
import DisciplineGroupForm from '../Components/DisciplineGroups/DisciplineGroupForm/DisciplineGroupForm';
import PrivateRoute from './PrivateRoute';
import NotFoundPage from './NotFoundPage';
import DisciplineSubgroups from '../Components/DisciplineSubgroups/DisciplineSubgroups';
import AuthGuard from './AuthGuard';
import CompetenceTemplates from '../Components/CompetenceTemplates/CompetenceTemplates';
import MyDisciplines from '../Components/MyDisciplines/MyDisciplines';
import EAFSGAreas from '../Components/EAFSGAreas/EAFSGAreas';
import EAFSGAreaForm from '../Components/EAFSGAreas/EAFSGAreaForm/EAFSGAreaForm';

const Router = () => {
  const isAdmin = useIsAdmin();
  const isFacultyAdmin = useIsFacultyAdmin();

  return (
    <BrowserRouter>
      <AuthGuard>
      <Switch>
        <Route exact path='/' component={Home} />
        <Route path='/autentificare' component={Login} />
        <Route path='/info' component={Info} />
        <Route path='/notificari' component={Notifications} />
        <Route path='/disciplinele-mele' component={MyDisciplines} />
        <Route path='/:studyCycle/programe' component={StudyPrograms} />
        <Route path='/:studyCycle/editare-program/:programId' component={StudyProgramForm} />
        <Route path='/:studyCycle/adaugare-program' component={StudyProgramForm} />

        {/* Domenii */}
        <PrivateRoute condition={() => isAdmin} path='/domenii' component={DomainTabs} />
        <PrivateRoute condition={() => isAdmin} path='/editare-domeniu/:domainId' component={DomainForm} />
        <PrivateRoute condition={() => isAdmin} path='/adaugare-domeniu' component={DomainForm} />
        <PrivateRoute condition={() => isAdmin} path='/editare-indicator/:scopeType/:scopeId/:indicatorId' component={IndicatorForm} />
        <PrivateRoute condition={() => isAdmin} path='/adaugare-indicator/:scopeType/:scopeId' component={IndicatorForm} />
        <PrivateRoute condition={() => isAdmin} path='/adaugare-domeniu-fundamental' component={FundamentalDomainForm} />
        <PrivateRoute condition={() => isAdmin} path='/editare-domeniu-fundamental/:fundamentalDomainId' component={FundamentalDomainForm} />
        <PrivateRoute condition={() => isAdmin} path='/adaugare-science-branch' component={ScienceBranchForm} />
        <PrivateRoute condition={() => isAdmin} path='/editare-science-branch/:scienceBranchId' component={ScienceBranchForm} />
        <PrivateRoute condition={() => isAdmin} path='/competente' component={CompetenceTemplates} />
        <PrivateRoute condition={() => isAdmin} path='/arii-eafsg' component={EAFSGAreas} />
        <PrivateRoute condition={() => isAdmin} path='/adaugare-arie-eafsg' component={EAFSGAreaForm} />
        <PrivateRoute condition={() => isAdmin} path='/editare-arie-eafsg/:eafsgAreaId' component={EAFSGAreaForm} />

        {/* Sali */}
        <PrivateRoute condition={() => isAdmin || isFacultyAdmin} path='/laboratoare' component={Laboratories} />
        <PrivateRoute condition={() => isAdmin || isFacultyAdmin} path='/editare-laborator/:laboratoryId' component={LaboratoryForm} />
        <PrivateRoute condition={() => isAdmin || isFacultyAdmin} path='/adaugare-laborator' component={LaboratoryForm} />


        <Route path='/laboratoarePlan/:programId/:schoolYear' component={PlanLaboratories} />
        <Route path='/laboratoareContent/:programId/:schoolYear' component={LaboratoriesContent} />
        <Route path='/laboratoareEchipament/:programId/:schoolYear' component={LaboratoriesEquipment} />
        <Route path='/laboratoareCapacitate/:programId/:schoolYear' component={LaboratoriesCapacity} />

        <Route path='/:studyCycle/plan/:programId' component={Subjects} />
        <Route path='/:studyCycle/adaugare-disciplina-short/:programId' component={SubjectShortForm} />
        <Route path='/:studyCycle/editare-disciplina-short/:programId/:subjectId' component={SubjectShortForm} />
        <Route path='/:studyCycle/editare-disciplina/:programId/:subjectId' component={SubjectForm} />
        <Route path='/:studyCycle/adaugare-disciplina/:programId' component={SubjectForm} />
        <Route path='/indicatori/:scopeType/:scopeId' component={Indicators} />
        <Route path='/statusIndicatori/:studyProgramId/:planYear' component={IndicatorsStats} />

        {/* Grupuri discipline */}
        <Route path="/discipline-groups/:groupId/subgroups" component={DisciplineSubgroups} />
        <Route path='/grupuriDiscipline/:studyPlanId' component={DisciplineGroups} />
        <Route path='/editare-grup/:disciplineGroupId' component={DisciplineGroupForm} />
        <Route path='/adaugare-grup' component={DisciplineGroupForm} />


        <Route path="/:studyCycle/learning-competences/:programId" component={LearningCompetences} />
        <Route path='/:studyCycle/editare-raport/:reportType/:programId/:reportId' component={ReportForm} />
        <Route path='/:studyCycle/adaugare-raport/:reportType/:programId' component={ReportForm} />
        <Route path='/:studyCycle/:reportType/:programId' component={ReportsList} />
				<Route path="/404" component={NotFoundPage} />
        
      </Switch>
      </AuthGuard>
    </BrowserRouter>
  );
};

export default Router;